export default "__VITE_ASSET__CBFQ7UDc__"